<template>
  <v-app>
    <router-view
      v-if="(!token || userType === 'admin' || userType === 'lessor') && mount"
      name="drawer"
    />
    <v-main
      v-if="
        (!token ||
          userType === 'admin' ||
          userType === 'lessor' ||
          userType === 'tenant') &&
        mount
      "
    >
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
      <Footer v-if="!mobile"></Footer>
    </v-main>
    <!-- <ComingSoon component="Tenant" v-if="token && userType==='tenant'"></ComingSoon> -->
    <Dialog ref="confirm"></Dialog>
    <div class="stick-bottom d-flex flex-column justify-space-around">
      <BottomAlert v-if="mount" :token="token" :user="user"></BottomAlert>
    </div>
    <v-overlay :value="loading" fixed style="z-index: 203">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <snackbar ref="snackbar"></snackbar>
  </v-app>
</template>

<script>
import Dialog from './components/Dialog.vue'
import Footer from './components/Footer.vue'
import BottomAlert from './components/alerts/BottomAlert.vue'
import Snackbar from './components/Snackbar.vue'

export default {
  name: 'App',
  components: {
    Dialog,
    Footer,
    BottomAlert,
    Snackbar
  },
  data: () => {
    return {
      right: null,
      mount: false,
      loading: false
    }
  },
  computed: {
    userType() {
      return this.$store.getters['auth/getUser'].userType
    },
    token() {
      return localStorage.getItem('token')
    },
    currentProperty() {
      return this.$store.getters['auth/getUser'].selectedProperty
    },
    user() {
      return this.$store.getters['auth/getUser']
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  async mounted() {
    this.$root.$setLoading = this.setLoading
    this.setLoading(true)
    await this.$store.dispatch('auth/fetchCurrentUserAction').catch(() => {})
    await this.$store.dispatch('properties/fetchPropertyAction').catch(() => {})
    if (this.currentProperty) {
      await this.$store
        .dispatch('roles/fetchRoleFeaturesAction')
        .catch(() => {})
      await this.fetchRequiredActions()
    }
    this.$root.$confirm = this.$refs.confirm.open
    this.$root.$role = this.$store.getters['roles/getRole']
    this.$root.$roleAccess = this.$store.getters['roles/getFeatureAccess']
    this.$root.$snack = this.$refs.snackbar.activate
    // this.$root.$currentProperty = this.currentProperty
    this.setLoading(false)
    this.mount = true
  },
  methods: {
    setLoading(value) {
      this.loading = value
    },
    async fetchRequiredActions() {
      this.$store
        .dispatch('appBarNotifications/fetchAppBarNotificationsAction')
        .catch(() => {})
      this.$store.dispatch('users/fetchAliasesAction').catch(() => {})
      this.$store.dispatch('pdcs/fetchDuePdcsAction').catch(() => {})
      this.$store
        .dispatch('units/fetchUnitsFlatAction', {
          propertyId: this.currentProperty.propertyId
        })
        .catch(() => {})
    }
  },
  sockets: {
    connect() {
      // need this to keep the room alive
      this.$socket.client.emit('init', this.user.userId)
    }
  }
}
</script>

<style>
.v-main {
  background-color: #f4f7f9;
}
p,
.v-list-item__title {
  /*color: #373D3F;*/
  color: #424242;
}
span {
  color: #424242;
}
.v-step {
  z-index: 2;
}
.v-dialog {
  border-radius: 12px !important;
}

.v-dialog--active {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.container {
  width: auto;
}

.text-tiny {
  font-size: 0.6rem !important;
  font-weight: 500;
  letter-spacing: 0.1666666667em;
  text-transform: uppercase;
}

.denser.v-data-table--dense .v-data-table__wrapper table tbody tr td,
.denser.v-data-table--dense .v-data-table__wrapper table thead tr th {
  padding: 0px 8px 0px 0px !important;
}
</style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.stick-bottom {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 7;
}
</style>
